import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { OktaConfig, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
@Component({
  selector: 'fl-fl-okta-callback',
  templateUrl: './fl-okta-callback.component.html',
  styleUrls: ['./fl-okta-callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlOktaCallbackComponent implements OnInit, OnDestroy {
  public error: string;
  private _redirectUri = '/';
  private _timeout: any;

  constructor(
    @Inject(OKTA_CONFIG) private oktaConfig: OktaConfig,
    private _oktaAuth: OktaAuth,
    private _cd: ChangeDetectorRef,
    @Optional() private injector?: Injector,
  ) {
    try {
      const uri = this._oktaAuth.getOriginalUri() ?? '/';
      if (!uri.includes('implicit/callback')) {
        this._redirectUri = uri;
      }
    } catch {}
  }

  public async ngOnInit() {
    try {
      // Parse code or tokens from the URL, store tokens in the TokenManager, and redirect back to the originalUri
      this._timeout = setTimeout(() => this._navigate(), 5000);
      await this._oktaAuth.handleLoginRedirect();
    } catch (e) {
      const err: any = e;
      // Callback from social IDP. Show custom login page to continue.
      if (this._oktaAuth.isInteractionRequiredError(err) && this.injector) {
        const { onAuthResume, onAuthRequired } = this.oktaConfig;
        const callbackFn = onAuthResume || onAuthRequired;
        if (callbackFn) {
          callbackFn(this._oktaAuth, this.injector);
          return;
        }
      }
      this.error = err.toString();
      this._cd.markForCheck();
      // tslint:disable-next-line: no-console
      console.error('TcsOktaCallbackComponent:', e);

      clearTimeout(this._timeout);
      this._timeout = setTimeout(() => this._navigate(), 3000);
    }
  }

  public ngOnDestroy() {
    clearTimeout(this._timeout);
  }

  private _navigate() {
    window.location.href = this._redirectUri;
  }
}
